import React, { useState } from "react";
import { Card, Dropdown, Row, Col } from "react-bootstrap";
import { FiCalendar } from "react-icons/fi";

export default function ViolationsStatistics() {
  const [filter, setFilter] = useState("Today");

  return (
    <Card className="violation-card h-100">
      <Card.Body>

        {/* HEADER */}
        <div className="violation-header">
          <h5>Violations Statistics</h5>

          <Dropdown>
            <Dropdown.Toggle className="violation-dropdown">
              <FiCalendar /> {filter}
            </Dropdown.Toggle>

            <Dropdown.Menu>
              {["Today", "Weekly", "Monthly"].map((item) => (
                <Dropdown.Item key={item} onClick={() => setFilter(item)}>
                  {item}
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>
        </div>

        {/* CONTENT */}
        <Row className="align-items-center">
          {/* LEFT TEXT */}
          <Col sm={7}>
            <p className="stat-text">
              <span className="stat-dot orange"></span>
              Late Arrivals
            </p>

            <p className="stat-text">
              <span className="stat-dot teal"></span>
              Missing Punches
            </p>

            <p className="stat-text">
              <span className="stat-dot green"></span>
              Attendance Below 75%
            </p>
          </Col>

          {/* RIGHT CHART */}
          <Col sm={5}>
            <div className="bars-wrapper">

              <div className="bar-item">
                <span>90%</span>
                <div className="bar orange-bar"></div>
              </div>

              <div className="bar-item">
                <span>50%</span>
                <div className="bar teal-bar"></div>
              </div>

              <div className="bar-item">
                <span>75%</span>
                <div className="bar green-bar"></div>
              </div>

            </div>
          </Col>
        </Row>

      </Card.Body>

      {/* INTERNAL CSS */}
      <style>{`

/* CARD */
.violation-card {
  border-radius: 1px;
  border: 2px solid #e5e7eb;
}

/* HEADER */
.violation-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 25px;
}

.violation-header h5 {
  font-weight: 600;
  margin: 0;
}

/* DROPDOWN */
.violation-dropdown {
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  font-size: 13px;
  border-radius: 8px;
  padding: 6px 12px;
  color: #111;
}

.violation-dropdown svg {
  margin-right: 6px;
}

.dropdown-item:hover {
  background-color: #faf9f8;
}
/* TEXT LIST */
.stat-text {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 14px;
  font-size: 15px;
  color: #111827;
}

/* DOTS */
.stat-dot {
  width: 18px;
  height: 6px;
  border-radius: 10px;
  display: inline-block;
}

/* COLORS */
.orange {
  background: linear-gradient(to right, #ff7a18, #ff3d00);
}

.teal {
  background: linear-gradient(to right, #0f766e, #2dd4bf);
}

.green {
  background: linear-gradient(to right, #16a34a, #facc15);
}

/* BAR WRAPPER */
.bars-wrapper {
  display: flex;
  align-items: flex-end;
  justify-content: space-around;
  height: 130px;
  gap:3px;
}

/* EACH BAR */
.bar-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
}

/* LABEL */
.bar-item span {
  font-size: 11px;
  font-weight: 400;
  color: #111;
  border-radius: 15px;
   
}

/* BAR BASE */
.bar {
  width: 45px;
  border-radius: 10px;
}

/* BAR HEIGHTS */
.orange-bar {
  height: 120px;
  background: linear-gradient(to top, #ff3d00, #ff7a18);
}

.teal-bar {
  height: 70px;
  background: linear-gradient(to top, #0f766e, #2dd4bf);
}

.green-bar {
  height: 100px;
  background: linear-gradient(to top, #facc15, #16a34a);
}

/* MOBILE */
@media (max-width: 768px) {

  .violation-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }

  .violation-dropdown {
    width: 100%;
  }

  .bars-wrapper {
    margin-top: 20px;
    justify-content: space-between;
  }

  .bar {
    width: 30px;
  }

  .stat-text {
    font-size: 14px;
  }
}

      `}</style>
    </Card>
  );
}